(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.menu-toggle').forEach((toggle) => {
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;
    const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';
    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      nav.hidden = !open;
      if (open) {
        const firstLink = nav.querySelector('a');
        if (firstLink) firstLink.focus();
      } else {
        toggle.focus();
      }
    };
    toggle.addEventListener('click', () => setOpen(!isOpen()));
    nav.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { setOpen(false); return; }
      if (event.key !== 'Tab') return;
      // Trap focus within the open menu.
      const focusables = nav.querySelectorAll('a[href], button:not([disabled])');
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    // Close when the shopper interacts outside the open menu/toggle.
    document.addEventListener('pointerdown', (event) => {
      if (!isOpen()) return;
      if (nav.contains(event.target) || toggle.contains(event.target)) return;
      setOpen(false);
    });
  });

  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    let headerRaf = null;
    const setMetrics = () => {
      headerRaf = null;
      document.documentElement.style.setProperty('--header-h', siteHeader.offsetHeight + 'px');
    };
    // Coalesce the resize burst (orientation changes, mobile URL-bar show/hide) into one
    // layout read+write per animation frame instead of thrashing on every resize tick.
    const onHeaderResize = () => {
      if (headerRaf == null) headerRaf = requestAnimationFrame(setMetrics);
    };
    setMetrics();
    window.addEventListener('resize', onHeaderResize, { passive: true });
    if (siteHeader.classList.contains('site-header--overlay')) {
      const onScroll = () => siteHeader.classList.toggle('is-scrolled', window.scrollY > 8);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  // ---- On-page predictive search panel ----
  const searchPanel = document.getElementById('search-panel');
  if (searchPanel) {
    const searchToggles = document.querySelectorAll('[data-search-toggle]');
    const searchForm = searchPanel.querySelector('form');
    const searchInput = searchPanel.querySelector('[data-search-input]');
    const searchResults = searchPanel.querySelector('[data-search-results]');
    const searchBackdrop = document.querySelector('[data-search-backdrop]');
    // Liquid does not render inside javascript blocks, so the locale-aware
    // endpoint is read from the form's data attribute instead.
    const searchEndpoint = searchForm.getAttribute('data-predictive-url');
    let searchOpen = false;
    let searchDebounce = null;
    let searchController = null;
    let searchLastFocus = null;

    const setSearchOpen = (open) => {
      searchOpen = open;
      searchPanel.hidden = !open;
      if (searchBackdrop) searchBackdrop.hidden = !open;
      searchToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
      if (open) {
        searchLastFocus = document.activeElement;
        searchInput.focus();
      } else {
        clearTimeout(searchDebounce);
        if (searchController) searchController.abort();
        searchResults.innerHTML = '';
        searchInput.value = '';
        if (searchLastFocus && typeof searchLastFocus.focus === 'function') searchLastFocus.focus();
      }
    };

    searchToggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        setSearchOpen(!searchOpen);
      });
    });

    searchPanel.querySelectorAll('[data-search-close]').forEach((btn) => {
      btn.addEventListener('click', () => setSearchOpen(false));
    });

    // Esc closes; Tab is trapped within the open panel (mirrors the mobile menu).
    searchPanel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { setSearchOpen(false); return; }
      if (event.key !== 'Tab') return;
      const focusables = searchPanel.querySelectorAll('a[href], button:not([disabled]), input');
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchOpen) setSearchOpen(false);
    });

    // Close when interacting outside the open panel (the dim backdrop included),
    // unless the target is a search toggle.
    document.addEventListener('pointerdown', (event) => {
      if (!searchOpen) return;
      if (searchPanel.contains(event.target)) return;
      let onToggle = false;
      searchToggles.forEach((toggle) => { if (toggle.contains(event.target)) onToggle = true; });
      if (onToggle) return;
      setSearchOpen(false);
    });

    const runSearch = (term) => {
      if (searchController) searchController.abort();
      searchController = new AbortController();
      const url = searchEndpoint
        + '?q=' + encodeURIComponent(term)
        + '&resources[type]=product,article'
        + '&resources[limit]=6'
        + '&resources[limit_scope]=each'
        + '&resources[options][unavailable_products]=last'
        + '&section_id=predictive-search';
      fetch(url, { signal: searchController.signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const section = doc.getElementById('shopify-section-predictive-search');
          searchResults.innerHTML = section ? section.innerHTML : '';
        })
        .catch((error) => {
          if (error.name !== 'AbortError') searchResults.innerHTML = '';
        });
    };

    searchInput.addEventListener('input', () => {
      const term = searchInput.value.trim();
      clearTimeout(searchDebounce);
      if (searchController) searchController.abort();
      if (term.length < 2) { searchResults.innerHTML = ''; return; }
      searchDebounce = setTimeout(() => runSearch(term), 220);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  // The video carries no `autoplay` (see markup) — start it only where it is
  // actually shown, so phones and reduced-motion users never download it.
  document.querySelectorAll('[data-hero-video]').forEach((video) => {
    if (!window.matchMedia('(min-width: 901px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    // Real section id (JSON-template sections render as `template--…__main`, NOT a
    // bare "main"), read from the Liquid-rendered data attribute — Liquid does not
    // run inside the javascript block, so the id must come from the DOM.
    var sectionRoot = document.querySelector('[data-cart-section]');
    var SECTION_ID = (sectionRoot && sectionRoot.getAttribute('data-section-id')) || 'main';

    function errorText() {
      var s = document.querySelector('[data-cart-section]');
      return (s && s.getAttribute('data-l-error')) || 'Error';
    }

    function setCount(n) {
      var nodes = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = n;
        nodes[i].classList.toggle('is-empty', !(n > 0));
      }
    }
    function refreshCount(json) {
      if (json && typeof json.item_count === 'number') { setCount(json.item_count); return; }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }

    function afterRender() {
      initSticky();
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        window.Shopify.PaymentButton.init();
      }
    }

    function applySection(json) {
      var htmlStr = json && json.sections && json.sections[SECTION_ID];
      // No rendered section came back — fall back to a full reload so the cart
      // always reflects the change instead of going silently stale.
      if (!htmlStr) { window.location.reload(); return; }
      var parsed = new DOMParser().parseFromString(htmlStr, 'text/html');
      // Key off [data-cart-section] in both the response and the live DOM so the
      // swap never depends on the exact shopify-section-* wrapper id.
      var fresh = parsed.querySelector('[data-cart-section]');
      var live = document.querySelector('[data-cart-section]');
      if (!fresh || !live) { window.location.reload(); return; }
      // First-party HTML from Shopify's Section Rendering API (same-origin, our own
      // section markup) — not user input, so innerHTML is safe here.
      live.innerHTML = fresh.innerHTML;
      afterRender();
    }

    function showCartError() {
      var box = document.querySelector('[data-cart-error]');
      if (!box) { window.location.reload(); return; }
      box.textContent = errorText();
      box.hidden = false;
    }

    function cartMutate(endpoint, body) {
      body.sections = [SECTION_ID];
      body.sections_url = window.location.pathname;
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (json) { if (!r.ok) throw json; return json; });
      }).then(function (json) {
        applySection(json);
        refreshCount(json);
        return json;
      }).catch(function (err) {
        showCartError();
        throw err;
      });
    }

    var clampQty = function (v) { return Math.max(0, parseInt(v, 10) || 0); };
    var qtyTimer = null;
    function changeLine(line, qty) {
      cartMutate('/cart/change.js', { line: parseInt(line, 10), quantity: clampQty(qty) });
    }

    // ---- Delegated handlers (bound once; survive section innerHTML swaps) ----

    document.addEventListener('click', function (e) {
      var stepBtn = e.target.closest ? e.target.closest('.cart__form .qty__btn') : null;
      if (stepBtn) {
        var input = document.getElementById(stepBtn.getAttribute('data-qty-target'));
        if (!input) return;
        var step = parseInt(stepBtn.getAttribute('data-qty-step'), 10) || 0;
        input.value = clampQty((parseInt(input.value, 10) || 0) + step);
        clearTimeout(qtyTimer);
        var ln = input.getAttribute('data-line');
        var val = input.value;
        qtyTimer = setTimeout(function () { changeLine(ln, val); }, 500);
        return;
      }
      var rm = e.target.closest ? e.target.closest('.cart-item__remove[data-line]') : null;
      if (rm) {
        e.preventDefault();
        changeLine(rm.getAttribute('data-line'), 0);
        return;
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('qty__input') || !input.hasAttribute('data-line')) return;
      clearTimeout(qtyTimer);
      changeLine(input.getAttribute('data-line'), input.value);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target;
      if (!input.classList || !input.classList.contains('qty__input') || !input.hasAttribute('data-line')) return;
      e.preventDefault();
      clearTimeout(qtyTimer);
      changeLine(input.getAttribute('data-line'), input.value);
    });

    // ---- Sticky mobile checkout (re-init after each render) ----
    var stickyObserver = null;
    function initSticky() {
      if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
      var bar = document.querySelector('[data-cart-sticky]');
      var checkout = document.querySelector('.cart__summary .cart__checkout');
      if (bar && checkout && 'IntersectionObserver' in window) {
        stickyObserver = new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { rootMargin: '0px 0px -8px 0px' });
        stickyObserver.observe(checkout);
      }
    }

    document.addEventListener('click', function (e) {
      var up = e.target.closest ? e.target.closest('[data-set-upgrade]') : null;
      if (!up) return;
      e.preventDefault();
      var setVar = parseInt(up.getAttribute('data-set-variant'), 10);
      if (!setVar) return;
      var knives = (up.getAttribute('data-knife-variants') || '').split(',').filter(Boolean);
      var updates = {};
      knives.forEach(function (v) { updates[v] = 0; });
      updates[setVar] = 1;
      cartMutate('/cart/update.js', { updates: updates });
    });

    initSticky();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('.toolbar').forEach((form) => {
    let debounce;
    form.addEventListener('change', (event) => {
      const target = event.target;
      if (target.matches('select')) {
        // Sort select: submit immediately.
        clearTimeout(debounce);
        form.submit();
      } else if (target.matches('input[type="checkbox"]')) {
        // Filter toggles: debounce so rapid toggling triggers one reload.
        clearTimeout(debounce);
        debounce = setTimeout(() => form.submit(), 400);
      }
    });

    // Filter dropdown cards: keep only one open, close on outside click / Escape.
    const cards = form.querySelectorAll('.filter-card');
    cards.forEach((card) => {
      card.addEventListener('toggle', () => {
        if (!card.open) return;
        cards.forEach((other) => { if (other !== card) other.open = false; });
      });
    });
    if (cards.length) {
      document.addEventListener('click', (event) => {
        cards.forEach((card) => {
          if (card.open && !card.contains(event.target)) card.open = false;
        });
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') cards.forEach((card) => { card.open = false; });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.pdp').forEach((root) => {
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent || '[]');
    const meta = JSON.parse(root.querySelector('[data-variant-meta]').textContent || '{}');
    const form = root.querySelector('.product-form');
    const idInput = root.querySelector('[data-variant-id]');
    const mainImg = root.querySelector('[data-main-media] img');
    const heroBtn = root.querySelector('[data-main-media]');
    const amountEl = root.querySelector('.info__price .price__amount');
    const wasEl = root.querySelector('.info__price .price__was');
    const saveEl = root.querySelector('.info__price .price__save');
    const savingsEl = root.querySelector('.info__price .price__savings');
    const saveAmtEl = root.querySelector('.info__price [data-save-amount]');
    const stickyPriceEl = root.querySelector('[data-sticky-price]');
    const stickyWasEl = root.querySelector('[data-sticky-was]');
    const atc = root.querySelector('[data-atc]');
    const atcText = root.querySelector('[data-atc-text]');
    // Assigned by the bundle block below so variant changes can refresh its state.
    let onVariantChange = null;

    // Recompute every price-bearing element from a variant meta entry.
    function applyPrice(m) {
      if (!m) return;
      if (amountEl && m.price) amountEl.textContent = m.price;
      if (stickyPriceEl && (m.stickyPrice || m.price)) stickyPriceEl.textContent = m.stickyPrice || m.price;
      if (wasEl) { if (m.compareAt) { wasEl.textContent = m.compareAt; wasEl.style.display = ''; } else { wasEl.style.display = 'none'; } }
      if (saveEl) { if (m.save) { saveEl.textContent = '−' + m.save + ' %'; saveEl.style.display = ''; } else { saveEl.style.display = 'none'; } }
      if (savingsEl) savingsEl.hidden = !m.compareAt;
      if (saveAmtEl) saveAmtEl.textContent = m.saveAmount || '';
      if (stickyWasEl) {
        if (m.compareAt) { stickyWasEl.textContent = m.compareAt; stickyWasEl.hidden = false; }
        else { stickyWasEl.hidden = true; }
      }
    }

    function selectedOptions() {
      return Array.from(form.querySelectorAll('input[type="radio"]:checked'))
        .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
        .map((r) => r.value);
    }

    function findVariant() {
      const opts = selectedOptions();
      if (!opts.length) return variants[0];
      return variants.find((v) => v.options.length === opts.length && v.options.every((o, i) => o === opts[i]));
    }

    // Close a playing gallery video and bring back the play facade, so thumb
    // clicks and variant media swaps never happen invisibly under the frame.
    function resetGalleryVideo() {
      const frame = root.querySelector('[data-video-frame].is-on');
      if (!frame) return;
      const iframe = frame.querySelector('iframe');
      if (iframe) iframe.remove();
      const inlineVideo = frame.querySelector('video');
      if (inlineVideo) inlineVideo.pause();
      frame.classList.remove('is-on');
      const play = root.querySelector('[data-video-play]');
      if (play) play.style.display = '';
      const playLabel = root.querySelector('.gallery__play-label');
      if (playLabel) playLabel.style.display = '';
    }

    function setMedia(id) {
      if (!id || !mainImg) return;
      const thumb = root.querySelector('.gallery__thumb[data-media-id="' + id + '"]');
      if (!thumb) return;
      resetGalleryVideo();
      // Keep the hero responsive across gallery swaps instead of pinning a flat 1200px.
      if (thumb.dataset.srcset) {
        mainImg.srcset = thumb.dataset.srcset;
        if (thumb.dataset.sizes) mainImg.sizes = thumb.dataset.sizes;
      } else {
        mainImg.removeAttribute('srcset');
      }
      mainImg.src = thumb.dataset.full;
      if (heroBtn) {
        heroBtn.dataset.mediaId = id;
        if (thumb.dataset.zoom) heroBtn.dataset.zoom = thumb.dataset.zoom;
        heroBtn.classList.toggle('is-video-media', thumb.classList.contains('is-video'));
      }
      root.querySelectorAll('.gallery__thumb').forEach((t) => t.classList.toggle('is-active', t === thumb));
    }

    function update() {
      const v = findVariant();
      form.querySelectorAll('.swatch').forEach((s) => {
        const input = s.querySelector('input');
        s.classList.toggle('is-selected', input.checked);
      });
      if (!v) {
        if (atc) {
          atc.setAttribute('aria-disabled', 'true');
          if (atcText) atcText.textContent = atc.dataset.soldText || atcText.textContent;
        }
        return;
      }
      if (idInput) idInput.value = v.id;
      form.querySelectorAll('.option__val').forEach((el, i) => { el.textContent = v.options[i]; });
      const m = meta[v.id] || {};
      applyPrice(m);
      if (atc) {
        atc.setAttribute('aria-disabled', String(!m.available));
        if (atcText) atcText.textContent = m.available ? (atc.dataset.addText || atcText.textContent) : (atc.dataset.soldText || atcText.textContent);
      }
      const stockFlag = root.querySelector('[data-stock-flag]');
      if (stockFlag) stockFlag.hidden = !m.available;
      const stickyBtn = root.querySelector('[data-sticky-add]');
      const setCta = root.querySelector('[data-bundle-cta]');
      if (stickyBtn && (!setCta || setCta.hidden)) stickyBtn.disabled = !m.available;
      // Set products: re-derive the "bought separately" saving and the
      // set-contains totals (they live in another section, hence document-wide).
      if (m.setSaving !== undefined) {
        document.querySelectorAll('[data-set-saving-amount]').forEach((el) => { el.textContent = m.setSaving || ''; });
        document.querySelectorAll('[data-set-savings-row]').forEach((el) => { el.style.display = m.setSaving ? '' : 'none'; });
        document.querySelectorAll('[data-set-pay]').forEach((el) => { el.textContent = m.price || ''; });
      }
      setMedia(m.mediaId);
      if (onVariantChange) onVariantChange(m);
    }

    form.querySelectorAll('input[type="radio"]').forEach((r) => r.addEventListener('change', update));

    const clampQty = (value) => Math.min(99, Math.max(1, value));
    root.querySelectorAll('.qty__btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = root.querySelector('.qty__input');
        const step = parseInt(btn.dataset.qtyStep, 10);
        input.value = clampQty((parseInt(input.value, 10) || 1) + step);
      });
    });
    // Keep the ATC focusable + announceable: convert any server-rendered [disabled]
    // (no-JS safety for a sold-out variant) into aria-disabled now that JS guards submit.
    if (atc && atc.disabled) {
      atc.disabled = false;
      atc.setAttribute('aria-disabled', 'true');
    }

    // The form is novalidate — normalize a typed "0"/blank/oversized quantity
    // before it posts to /cart/add.
    if (form) {
      form.addEventListener('submit', (e) => {
        // Bundle "set" mode: the visible CTA is a link to the set product, not this
        // form — never post the single variant at the set price the UI is showing.
        const setCta = root.querySelector('[data-bundle-cta]');
        if (setCta && !setCta.hidden && setCta.getAttribute('href')) {
          e.preventDefault();
          window.location = setCta.getAttribute('href');
          return;
        }
        // Unavailable variant: ATC is aria-disabled (still focusable), so block here.
        if (atc && atc.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          return;
        }
        const qtyInput = form.querySelector('.qty__input');
        if (qtyInput) qtyInput.value = clampQty(parseInt(qtyInput.value, 10) || 1);
      });
    }

    root.querySelectorAll('.gallery__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => setMedia(thumb.dataset.mediaId));
    });

    // Video facade — only present when the product has a video media item.
    const videoHero = root.querySelector('.gallery__hero[data-video-hero]');
    if (videoHero) {
      const play = videoHero.querySelector('[data-video-play]');
      const label = videoHero.querySelector('.gallery__play-label');
      const frame = videoHero.querySelector('[data-video-frame]');
      if (play && frame) {
        // For YouTube/Vimeo embeds, warm the CDN connection on first hover/focus so
        // the click pays less DNS/TLS setup latency before the iframe loads.
        if (frame.dataset.videoType === 'external_video') {
          let warmed = false;
          const warm = () => {
            if (warmed) return;
            warmed = true;
            const host = frame.dataset.videoHost === 'vimeo' ? 'https://player.vimeo.com' : 'https://www.youtube-nocookie.com';
            ['preconnect', 'dns-prefetch'].forEach((rel) => {
              if (document.head.querySelector('link[rel="' + rel + '"][href="' + host + '"]')) return;
              const l = document.createElement('link');
              l.rel = rel;
              l.href = host;
              if (rel === 'preconnect') l.crossOrigin = '';
              document.head.appendChild(l);
            });
          };
          videoHero.addEventListener('pointerenter', warm, { once: true });
          videoHero.addEventListener('focusin', warm, { once: true });
        }
        play.addEventListener('click', () => {
          if (frame.dataset.videoType === 'external_video') {
            if (!frame.querySelector('iframe')) {
              const id = frame.dataset.videoId;
              const host = frame.dataset.videoHost;
              const src = host === 'vimeo'
                ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
                : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
              const iframe = document.createElement('iframe');
              iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
              iframe.setAttribute('allowfullscreen', '');
              iframe.setAttribute('title', play.getAttribute('aria-label') || 'Video');
              iframe.src = src;
              frame.appendChild(iframe);
            }
          } else {
            const video = frame.querySelector('video');
            if (video) video.play();
          }
          frame.classList.add('is-on');
          play.style.display = 'none';
          if (label) label.style.display = 'none';
        });
      }
    }

    const stickyAdd = root.querySelector('[data-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', () => {
        // In bundle "set" mode the real add button is hidden and a set CTA link
        // is shown — the sticky bar must follow that link, not click a hidden ATC.
        const setCta = root.querySelector('[data-bundle-cta]');
        if (setCta && !setCta.hidden && setCta.getAttribute('href')) {
          window.location = setCta.getAttribute('href');
        } else if (atc) {
          atc.click();
        }
      });
    }

    const sticky = root.querySelector('[data-sticky-buy]');
    const buyBlock = root.querySelector('.buy');
    if (sticky && buyBlock && 'IntersectionObserver' in window) {
      const obs = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 });
      obs.observe(buyBlock);
    }

    // Bundle upsell — independent of variant matching.
    const bundle = root.querySelector('[data-bundle]');
    if (bundle) {
      const bundleCta = root.querySelector('[data-bundle-cta]');
      const priceAmount = root.querySelector('.info__price .price__amount');
      const singleOpt = bundle.querySelector('.bundle__opt[data-kind="single"]');
      const stickyBtn = root.querySelector('[data-sticky-add]');
      const stickyLabel = stickyBtn ? stickyBtn.textContent : '';

      // Live single-knife state — starts from the server-rendered variant and is
      // refreshed on every variant change, so re-selecting "single" never
      // restores a stale price and the −% badge survives bundle round-trips.
      let single = {
        price: singleOpt ? singleOpt.dataset.price : (priceAmount ? priceAmount.textContent : ''),
        compareAt: singleOpt ? (singleOpt.dataset.compareAt || null) : null,
        save: null,
      };
      const initialMeta = idInput ? meta[idInput.value] : null;
      if (initialMeta) {
        single = { price: initialMeta.price, compareAt: initialMeta.compareAt, save: initialMeta.save };
      }

      function selectBundle(opt) {
        bundle.querySelectorAll('.bundle__opt').forEach((o) => o.setAttribute('aria-checked', String(o === opt)));
        const isSet = opt.dataset.kind === 'set';
        if (isSet) {
          const price = opt.dataset.price || single.price;
          applyPrice({
            price: price,
            stickyPrice: price,
            compareAt: opt.dataset.compareAt || null,
            save: null,
          });
        } else {
          applyPrice({ price: single.price, stickyPrice: single.price, compareAt: single.compareAt, save: single.save });
        }
        if (atc) atc.hidden = isSet;
        if (bundleCta) {
          bundleCta.hidden = !isSet;
          if (isSet && opt.dataset.href) bundleCta.setAttribute('href', opt.dataset.href);
        }
        if (stickyBtn) {
          // The sticky bar follows the visible CTA: label + enabled state.
          stickyBtn.textContent = isSet && bundleCta ? bundleCta.textContent : stickyLabel;
          stickyBtn.disabled = isSet ? false : (atc ? atc.getAttribute('aria-disabled') === 'true' : false);
        }
      }

      onVariantChange = (m) => {
        single = { price: m.price, compareAt: m.compareAt, save: m.save };
        if (singleOpt) {
          if (m.price) singleOpt.dataset.price = m.price;
          const singlePriceEl = singleOpt.querySelector('.bundle__price');
          if (singlePriceEl && m.price) singlePriceEl.textContent = m.price;
        }
        const checked = bundle.querySelector('.bundle__opt[aria-checked="true"]');
        if (checked && checked.dataset.kind === 'set') {
          // Keep showing the set's price, not the just-applied variant price.
          selectBundle(checked);
        }
      };

      // ARIA radio pattern: arrow keys move selection within the group.
      bundle.addEventListener('keydown', (e) => {
        if (!['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        const opts = Array.from(bundle.querySelectorAll('.bundle__opt'));
        const idx = opts.indexOf(document.activeElement);
        if (idx === -1) return;
        e.preventDefault();
        const dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
        const next = opts[(idx + dir + opts.length) % opts.length];
        next.focus();
        selectBundle(next);
      });

      bundle.addEventListener('click', (e) => {
        const opt = e.target.closest('.bundle__opt');
        if (opt) selectBundle(opt);
      });
    }

    // Social-proof toast — cycles through messages one at a time, dismissible.
    const toast = root.querySelector('[data-toast]');
    const toastMsgScript = root.querySelector('[data-toast-messages]');
    if (toast && toastMsgScript) {
      let messages = [];
      try { messages = JSON.parse(toastMsgScript.textContent || '[]'); } catch (e) { messages = []; }
      messages = messages.filter((m) => Array.isArray(m) && m[0]);
      if (messages.length) {
        const nameEl = toast.querySelector('[data-toast-name]');
        const itemEl = toast.querySelector('[data-toast-item]');
        const timeEl = toast.querySelector('[data-toast-time]');
        const closeBtn = toast.querySelector('[data-toast-close]');
        let i = 0;
        let shown = 0;
        let stopped = false;
        // Cap total impressions so the cycler can't run for the whole page lifetime,
        // and never wake a backgrounded tab — resume only when it becomes visible again.
        const maxShown = messages.length * 2;
        function showToast() {
          if (stopped) return;
          const msg = messages[i % messages.length];
          if (nameEl) nameEl.textContent = msg[0] || '';
          if (itemEl) itemEl.textContent = msg[1] || '';
          if (timeEl) timeEl.textContent = msg[2] || '';
          toast.hidden = false;
          requestAnimationFrame(() => toast.classList.add('is-on'));
          shown++;
          setTimeout(hideToast, 5000);
        }
        function scheduleNext() {
          if (stopped || shown >= maxShown) return;
          if (document.visibilityState === 'visible') {
            i++;
            setTimeout(showToast, 9000);
          } else {
            document.addEventListener('visibilitychange', function resume() {
              document.removeEventListener('visibilitychange', resume);
              scheduleNext();
            });
          }
        }
        function hideToast() {
          toast.classList.remove('is-on');
          setTimeout(() => { if (!stopped) scheduleNext(); }, 500);
        }
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            stopped = true;
            toast.classList.remove('is-on');
            setTimeout(() => { toast.hidden = true; }, 500);
          });
        }
        setTimeout(showToast, 6000);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.video-hero[data-video-id]').forEach((fig) => {
    const btn = fig.querySelector('.video-play');
    if (!btn) return;
    // Warm the embed CDN connection on first hover/focus so the click pays less
    // DNS/TLS setup latency before the iframe can start loading.
    let warmed = false;
    const warm = () => {
      if (warmed) return;
      warmed = true;
      const host = fig.dataset.videoType === 'vimeo' ? 'https://player.vimeo.com' : 'https://www.youtube-nocookie.com';
      ['preconnect', 'dns-prefetch'].forEach((rel) => {
        if (document.head.querySelector('link[rel="' + rel + '"][href="' + host + '"]')) return;
        const l = document.createElement('link');
        l.rel = rel;
        l.href = host;
        if (rel === 'preconnect') l.crossOrigin = '';
        document.head.appendChild(l);
      });
    };
    fig.addEventListener('pointerenter', warm, { once: true });
    fig.addEventListener('focusin', warm, { once: true });
    btn.addEventListener('click', () => {
      const id = fig.dataset.videoId;
      const type = fig.dataset.videoType;
      const src = type === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
        : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.className = 'video-hero__frame';
      iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      const cap = fig.querySelector('.video-hero__cap');
      iframe.title = cap ? cap.textContent : 'Video';
      fig.appendChild(iframe);
      fig.classList.add('is-playing');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
